import { IWixAPI } from '@wix/yoshi-flow-editor';
import { createNotFoundPageRouter } from '../../common/controller/create-router';
import { Router } from '../../common/router';
import { isFeedAdapterExperimentEnabled } from '../../common/selectors/experiment-selectors';
import { FEED_PAGE_NOT_FOUND } from '../../common/services/detect-route';
import { AppStore } from '../../common/types';
import {
  ROUTE_HOME,
  ROUTE_404,
  ROUTE_CATEGORY,
  ROUTE_CATEGORIES,
  ROUTE_SEARCH,
  ROUTE_LOGIN,
  ROUTE_ARCHIVE,
  ROUTE_TAGS,
  ROUTE_HASHTAG,
} from '../constants/routes';
import { createArchivePageRouter } from './create-routers/create-archive-page-router';
import { createCategoryPageRouter } from './create-routers/create-category-page-router';
import { createCategoryPageRouterWithAdapter } from './create-routers/create-category-page-router-with-adapter';
import { createFeedPageRouter } from './create-routers/create-feed-page-router';
import { createFeedPageRouterWithAdapter } from './create-routers/create-feed-page-router-with-adapter';
import { createHashtagPageRouter } from './create-routers/create-hashtag-page-router';
import { createSearchPageRouter } from './create-routers/create-search-page-router';
import { createTagPageRouter } from './create-routers/create-tag-page-router';

export const createRouter = (
  store: AppStore,
  _config: unknown,
  wixCodeApi: IWixAPI,
) => {
  const router = new Router();
  const isAdapterEnabled = isFeedAdapterExperimentEnabled(
    store.getState(),
    wixCodeApi.window.viewMode,
  );

  router.add(ROUTE_TAGS, createTagPageRouter(store, wixCodeApi));
  router.add(
    ROUTE_CATEGORIES,
    isAdapterEnabled
      ? createCategoryPageRouterWithAdapter(store, wixCodeApi)
      : createCategoryPageRouter(store, wixCodeApi),
    { preFetch: true },
  );

  router.add(
    ROUTE_CATEGORY,
    isAdapterEnabled
      ? createCategoryPageRouterWithAdapter(store, wixCodeApi)
      : createCategoryPageRouter(store, wixCodeApi),
    { preFetch: true },
  );
  router.add(ROUTE_SEARCH, createSearchPageRouter(store, wixCodeApi));
  router.add(ROUTE_HASHTAG, createHashtagPageRouter(store, wixCodeApi));
  router.add(ROUTE_ARCHIVE, createArchivePageRouter(store, wixCodeApi));
  router.add(
    ROUTE_HOME,
    isAdapterEnabled
      ? createFeedPageRouterWithAdapter(store, wixCodeApi)
      : createFeedPageRouter(store, wixCodeApi),
    { preFetch: true },
  );
  router.add(
    ROUTE_404,
    createNotFoundPageRouter(store, wixCodeApi, FEED_PAGE_NOT_FOUND, ROUTE_404),
  );
  router.add(ROUTE_LOGIN);
  router.fallback(ROUTE_404);
  return router;
};
